// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"app-components-track-artists-artists--container"};